import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

function DashboardPage() {
  const [sessions, setSessions] = useState([]);
  const [metrics, setMetrics] = useState({ sessionCount: 0 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const [sessionsRes, metricsRes] = await Promise.all([
          axios.get(`${API_URL}/sessions`),
          axios.get(`${API_URL}/metrics`),
        ]);
        setSessions(sessionsRes.data.sessions || []);
        setMetrics(metricsRes.data || { sessionCount: 0 });
        setError(null);
      } catch (err) {
        setError('Failed to fetch data. Is the backend running?');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
    const interval = setInterval(fetchData, 5000); // Auto-refresh every 5 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
        <div className="bg-white p-6 rounded-lg shadow">
          <h3 className="text-lg font-semibold text-gray-600">Active Sessions</h3>
          <p className="text-3xl font-bold text-gray-800">
            {loading ? '...' : metrics.sessionCount}
          </p>
        </div>
      </div>

      <div className="bg-white p-6 rounded-lg shadow">
        <h3 className="text-xl font-semibold text-gray-700 mb-4">Session List</h3>
        {loading && <p>Loading sessions...</p>}
        {error && <p className="text-red-500">{error}</p>}
        {!loading && !error && (
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Session ID
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {sessions.length > 0 ? (
                  sessions.map((sessionId) => (
                    <tr key={sessionId}>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-mono text-gray-700">
                        {sessionId}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                        <a href={`/session/${sessionId}`} className="text-indigo-600 hover:text-indigo-900">
                          View Details
                        </a>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="2" className="px-6 py-4 text-center text-gray-500">
                      No active sessions found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default DashboardPage;
